import React, { ReactNode } from "react";
import { KeyboardType, StyleProp, Text, ViewStyle, View } from "react-native";
import {
  BG_STYLES,
  BORDER_STYLES,
  COLORS,
  COMMON_STYLES,
  Input,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";

interface Props {
  value: string;
  placeholder: string;
  onChangeText?: (text: string) => void;
  onBlur?: (text: string) => void;
  keyboardType?: KeyboardType;
  maxLength?: number;
  error?: boolean;
  errorText?: string;
  onPress?: () => void;
  editable?: boolean;
  rightLabelIcon?: ReactNode;
  style?: StyleProp<ViewStyle>;
  containerStyle?: StyleProp<ViewStyle>;
}

const FormTextField = ({
  value,
  placeholder,
  onChangeText,
  onBlur,
  keyboardType,
  maxLength,
  error,
  errorText = value ? "Invalid Input Data" : "Field can not be empty",
  onPress,
  editable,
  rightLabelIcon,
  style,
  containerStyle,
}: Props) => {
  return (
    <View style={containerStyle}>
      <Input
        containerStyle={[
          BG_STYLES.bgWhite,
          COMMON_STYLES.b1,
          BORDER_STYLES.borderNeutral10,
          COMMON_STYLES.mb0,
          COMMON_STYLES.mt0,
          error && [BORDER_STYLES.borderError100],
          style,
        ]}
        label={placeholder}
        placeholderTextColor={COLORS.neutral70}
        placeholder={placeholder}
        onChangeText={onChangeText}
        value={value}
        keyboardType={keyboardType}
        onEndEditing={(e) => onBlur?.(e.nativeEvent.text)}
        maxLength={maxLength}
        onPress={onPress}
        editable={editable}
        rightLabelIcon={rightLabelIcon}
      />
      {error && errorText ? (
        <Text
          style={[
            TEXT_STYLES.textError100,
            VARIANTS_STYLES.MEDIUM,
            TYPOGRAPHY.CAPTION1,
            COMMON_STYLES["mt1/4"],
          ]}
        >
          {errorText}
        </Text>
      ) : null}
    </View>
  );
};

export default FormTextField;
